module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    class: {
      'index-sections': _vm.home, 'node-selector': !_vm.home
    }
  }, [(_vm.home) ? _c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("讨论节点分类导航")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row node-list"
  }, _vm._l((_vm.nodes), function(node) {
    return _c('NodeItem', {
      key: node.section,
      attrs: {
        "node": node
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc3f8b76!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/NodeList.vue
// module id = 292
// module chunks = 6